import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WhySection from './components/WhySection';
import SolutionSection from './components/SolutionSection';
import CategoryGrid from './components/CategoryGrid';
import CategoryScroll from './components/CategoryScroll';
import ComparisonSection from './components/ComparisonSection';
import ArticleLinkSection from './components/ArticleLinkSection';
import TestimonialSection from './components/TestimonialSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY Spreadsheet',
  url: 'https://yoybuyspreadsheet.cyou',
  description: 'Удобная система заказов из Китая через таблицу YOYBUY Spreadsheet. Покупайте на Taobao, 1688 и других китайских платформах без ошибок, переплат и путаницы.',
  inLanguage: 'ru-RU',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://yoybuyspreadsheet.cyou/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'YOYBUY Spreadsheet',
  url: 'https://yoybuyspreadsheet.cyou',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
  description: 'Автоматизированная система заказов из Китая через таблицу YOYBUY Spreadsheet.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <AboutSection />
          <WhySection />
          <SolutionSection />
          <CategoryGrid />
          <CategoryScroll />
          <ComparisonSection />
          <ArticleLinkSection />
          <TestimonialSection />
          <TrustSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}